import classnames from 'classnames';

import {CopyIconButton} from 'shells/button/copy-button/copy-icon-button';
import {colors} from 'shells/colors/colors';
import {CheckCircleSolidIcon} from 'shells/icon/svg/check-circle-solid-icon';
import {EnvelopeNewIcon} from 'shells/icon/svg/envelope-new-icon';
import {VerticalConnectorIcon} from 'shells/icon/svg/vertical-connector-icon';
import {WarningIcon} from 'shells/icon/svg/warning-icon';
import {Stack} from 'shells/layout/stack/stack';
import {Body} from 'shells/typography/body';

import styles from './forwarding-address-flow.module.css';

interface Props {
    emailAddress: string | undefined;
    nutshellAddress: string;
    isVerified: boolean;
}

export function ForwardingAddressFlow(props: Props) {
    return (
        <>
            <Body color='light' size='small'>
                Forward all emails from:
            </Body>
            <Stack isHorizontal={true} spacing={8} alignItems='center'>
                <div className={styles['icon-container']}>
                    <EnvelopeNewIcon size={20} alignCenter={true} />
                </div>
                <Body isBold={true} color='dark'>
                    {props.emailAddress}
                </Body>
            </Stack>
            <div className='pos-relative flex align-center justify-center'>
                <VerticalConnectorIcon size={48} wrapWithDiv={false} />
                <div className={styles['connector-icon']}>
                    {props.isVerified ? (
                        // @ts-expect-error
                        <CheckCircleSolidIcon size={20} color={colors.green} />
                    ) : (
                        <WarningIcon
                            size={20}
                            // @ts-expect-error
                            color={colors.orangeAttention}
                            wrapWithDiv={false}
                        />
                    )}
                </div>
            </div>
            <Stack isHorizontal={true} spacing={8} alignItems='center'>
                <div
                    className={classnames(
                        styles['icon-container'],
                        styles['icon-container--orange']
                    )}
                >
                    <EnvelopeNewIcon
                        size={20}
                        // @ts-expect-error
                        color={colors.orange}
                        wrapWithDiv={false}
                    />
                </div>
                <Body isBold={true} color='dark'>
                    {props.nutshellAddress}
                </Body>
                <CopyIconButton text={props.nutshellAddress} size='small' />
            </Stack>
        </>
    );
}
